import React from 'react'
import parse from 'html-react-parser'
import sanitize from 'sanitize-html'
import { decodeHTML } from 'transformer'
import AdobePdfViewer from '../components/AdobePdfViewer'
import VideoEmbed from '../components/VideoEmbed'

export const sanitizedHtml = (html) => {
  return sanitize(html, { allowedTags: false, allowedAttributes: false })
}

const renderHtml = (html) => {
  let index = 0
  const options = {
    replace: (domNode) => {
      index++
      switch (domNode?.attribs?.class) {
        case 'article-body-video':
          return <VideoEmbed key={`article-body-video-${index}`} index={index} node={domNode} />
        case 'embed pdf-embed':
          return <AdobePdfViewer key={`pdf-embed-${index}`} url={domNode?.attribs?.['data-url']} />
        case 'instagram-embed':
          return <div dangerouslySetInnerHTML={{ __html: decodeHTML(domNode?.attribs?.['data-embed']) }} />
        default:
          return domNode
      }
    }
  }
  return parse(html, options)
}

export default renderHtml
